var path = 'scripts/views/directives/email-tooltip.html';
var html = "<div class=\"tooltip-summary-page\">\n    <span class=\"em-bold tooltip-title\" translate>oneIdentity.emailTooltip</span>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/directives/email-tooltip.html
// module id = 376
// module chunks = 0